import Image from 'next/image'
import { useState, type FC, useEffect, useRef } from 'react'
import clsx from 'clsx'

import { Button } from '@wartek-id/button-v1'
import { Textarea } from '@wartek-id/textarea'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import { IS_DEVELOPMENT } from 'app/KinerjaShared/constants/env'

type TProps = Omit<DialogProps, 'children'> & {
  isFinalizing?: boolean
  onClickConfirm: () => void
  onClickCancel: () => void
}

const DialogDeliveryConfirmationTahunan: FC<TProps> = ({
  isFinalizing,
  onClickConfirm = () => {},
  onClickCancel = () => {},
  ...props
}) => {
  const inputRef = useRef(null)
  const [textConsent, setTextConsent] = useState('')
  const consentScript =
    'Saya setuju untuk mengirim Predikat Kinerja ke Pegawai.'
  const submitConsent = textConsent === consentScript
  const isConsentDirty = textConsent !== ''
  const isConsentFieldInvalid = !submitConsent && isConsentDirty

  // To be executed everytime the dialog is opened/reopened
  useEffect(() => {
    if (props.isOpen) {
      setTextConsent('')
      inputRef.current?.focus()
    }
  }, [props.isOpen])

  return (
    <Dialog data-module="pengelolaan-kinerja" {...props}>
      <DialogOverlay />
      <DialogContent
        className={clsx('!rounded-lg', { wiggle: !IS_DEVELOPMENT })}
      >
        <div className="p-6 space-y-4">
          <Image
            alt=""
            src="/illustrations/img-publish-data.png"
            width={84}
            height={84}
          />
          <Text variant="display-sm">
            Kirim Predikat Kinerja (Tahunan) ke Pegawai?
          </Text>

          <Text variant="body-lg" color="subdued">
            Predikat Kinerja (Tahunan) hanya dapat diubah lagi melalui
            E-Kinerja.
          </Text>

          <Text variant="body-lg" color="subdued">
            Mohon ketik kalimat persetujuan di bawah ini:
          </Text>

          <div className="bg-blue-5 p-1 rounded">
            <Text
              variant="heading-sm"
              color="informational"
              className={clsx('select-none', '!text-blue-60')}
            >
              {consentScript}
            </Text>
          </div>

          <div className="!mt-5 w-80">
            <Textarea
              rows={3}
              placeholder="Ketik kalimat persetujuan di sini"
              id="persetujuan"
              ref={inputRef}
              onChange={(event) => {
                setTextConsent(event.target.value)
              }}
              isInvalid={isConsentFieldInvalid}
              errorMessage={
                isConsentFieldInvalid && 'Mohon cek ejaan dan coba lagi.'
              }
              defaultValue={IS_DEVELOPMENT ? consentScript : ''}
            />
          </div>

          <div className="flex gap-5 !mt-6">
            <Button
              size="lg"
              color="white"
              disabled={isFinalizing}
              isLoading={isFinalizing}
              onClick={onClickCancel}
              data-testid="btn-cancel"
              className="w-40"
            >
              Kembali
            </Button>
            <Button
              size="lg"
              disabled={isFinalizing || !submitConsent}
              isLoading={isFinalizing}
              onClick={onClickConfirm}
              data-testid="btn-confirm"
              className="w-40"
            >
              Lanjut
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default DialogDeliveryConfirmationTahunan
